import React from 'react';

import PropTypes from 'prop-types';

// material-ui
import { Box, Chip, Grid, Stack, Typography } from '@mui/material';

// project import
import MainCard from '../../MainCard';

// assets
import { FallOutlined, RiseOutlined } from '@ant-design/icons';

// ==============================|| STATISTICS - ECOMMERCE CARD  ||============================== //

const AnalyticTokensNeeded = ({
  color = 'primary',
  title,
  // count,
  percentage,
  // isLoss,
  extra,
  tokensIncluded,
  iterationsMonthly,
  tokensLeftAfterDeduction,
  tokensLeftThisMonth,
  tokensNeededMonthly,
  tokensNeededSingle,
  totalMonthly,
  totalSingle,
  hasData,
  isSingle,
}) => {

  // title,
  const count = '123'
  // percentage,
  // isLoss,
  // extra

  if (hasData) {
    return (
      <MainCard contentSX={{ p: 2.25 }}>
        <Stack spacing={0.5}>
          <Typography
            variant="h6"
            color="inherit"
            sx={{ fontWeight: 'bold' }}
          >
            {title}
          </Typography>
          <Grid container alignItems="center">
            <Grid item>
              <Typography
                variant="h4"
                // color="inherit"
                // color="textSecondary"
                // sx={{ color: `${color || 'primary'}.main` }}
                sx={{ color: `${color || 'primary'}.main` }}
              >

                {isSingle ? tokensNeededSingle : tokensNeededMonthly}

                <Typography
                  variant="h6"
                  component="span"
                  color="textSecondary"
                // sx={{ color: `${color || 'primary'}.main` }}
                >
                {' '} Tokens
                </Typography>

              </Typography>

            </Grid>
            {
              // percentage && (
              //   <Grid item>
              //     <Chip
              //       variant="combined"
              //       color={color}
              //       icon={
              //         <>
              //           {!isLoss && <RiseOutlined style={{ fontSize: '0.75rem', color: 'inherit' }} />}
              //           {isLoss && <FallOutlined style={{ fontSize: '0.75rem', color: 'inherit' }} />}
              //         </>
              //       }
              //       label={`${percentage}%`}
              //       sx={{ ml: 1.25, pl: 1 }}
              //       size="small"
              //     />
              //   </Grid>
              // )
            }
          </Grid>
        </Stack>
        <Box sx={{ pt: 0 }}>
          <Typography variant="caption" color="textSecondary">
            You have used {' '}
            <Typography component="span" variant="caption" sx={{ color: `${color || 'primary'}.main` }}>
              {tokensIncluded - tokensLeftThisMonth}
            </Typography>{' '}
            of {' '}
            <Typography component="span" variant="caption" sx={{ color: `${color || 'primary'}.main` }}>
              {tokensIncluded}
            </Typography>{' '} monthly tokens
          </Typography>
        </Box>
      </MainCard>
    )
  }
  else {
    return (
      <MainCard contentSX={{ p: 2.25, height: '136px' }}>
        <Stack spacing={0.5}>
          <Typography variant="h6" color="inherit">
            {title}
          </Typography>
          <Grid container alignItems="center">
            <Grid item>
              <Typography
                variant="h4"
                color="textSecondary"
              // color="inherit"
              // sx={{ color: `${color || 'primary'}.main` }}
              >
                No Data
              </Typography>
            </Grid>
          </Grid>
        </Stack>

      </MainCard>
    )
  }



};

AnalyticTokensNeeded.propTypes = {
  title: PropTypes.string,
  // count: PropTypes.number,
  percentage: PropTypes.number,
  isLoss: PropTypes.bool,
  color: PropTypes.string,
  extra: PropTypes.string,
  tokensIncluded: PropTypes.number,
  tokensLeftThisMonth: PropTypes.number,
  hasData: PropTypes.bool,
  isSingle: PropTypes.bool,
};

export default AnalyticTokensNeeded;
